/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-22, 13:53:59
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 14:15:40
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
import {
  COMPLETE_LIST,
  TOGGLE_SERVICE_STATUS_CHANGE_RESULT,
  CLEAR_SERVICE_STATUS_CHANGE_RESULT,
  SET_RESPONSE_CODE,
  CLEAR_RESPONSE_CODE,
  TOOGLE_SERVICES_LIST_LOADING,
  TOOGLE_CHANGE_STATUS_LOADING,
  COMPLETE_PACKAGE_USAGE,
  TOOGLE_GET_USAGE_LOADING,
  SET_SERVICE_STATUS_CONFIRMATION_REQUIRED,
  CLEAR_SERVICE_STATUS_CONFIRMATION_REQUIRED,
} from './mutation-types';

export default {
  [COMPLETE_LIST](state, payload) {
    const _state = state;
    _state.servicesList = payload.list;
  },
  [COMPLETE_PACKAGE_USAGE](state, payload) {
    const _state = state;
    _state.packageUsage = payload.packageUsage;
  },
  [TOGGLE_SERVICE_STATUS_CHANGE_RESULT](state, payload) {
    const _state = state;
    if (payload.enabled !== false) {
      _state.hasServiceStatusBeenChange = !state.hasServiceStatusBeenChange;
    }
    _state.enabled = payload.enabled;
    _state.incorrect_code = payload.incorrectCode;
  },
  [CLEAR_SERVICE_STATUS_CHANGE_RESULT](state) {
    const _state = state;
    _state.hasServiceStatusBeenChange = false;
  },
  [SET_RESPONSE_CODE](state, payload) {
    const _state = state;
    _state.responseCode = payload.status;
  },
  [CLEAR_RESPONSE_CODE](state) {
    const _state = state;
    _state.responseCode = '200';
  },
  [TOOGLE_SERVICES_LIST_LOADING](state) {
    const _state = state;
    _state.servicesListLoading = !_state.servicesListLoading;
  },
  [TOOGLE_CHANGE_STATUS_LOADING](state) {
    const _state = state;
    _state.changeStatusLoading = !_state.changeStatusLoading;
  },
  [TOOGLE_GET_USAGE_LOADING](state) {
    const _state = state;
    _state.getUsageLoading = !_state.getUsageLoading;
  },
  [SET_SERVICE_STATUS_CONFIRMATION_REQUIRED](state) {
    const _state = state;
    _state.confirmationRequired = true;
    _state.enabled = false;
    _state.incorrect_code = false;
  },
  [CLEAR_SERVICE_STATUS_CONFIRMATION_REQUIRED](state) {
    const _state = state;
    _state.confirmationRequired = false;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/Services/mutations.js